import React from "react";
import { Box } from "@mui/material";
import Header from "../Header";
import PageContent from "../PageContent";

const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        backgroundColor: "var(--bgLightGrey)",
      }}
    >
      <Box sx={{ width: "100%", overflowX: "hidden", height: "100vh" }}>
        <Header />
        <PageContent>{children}</PageContent>
      </Box>
    </Box>
  );
};

export default Layout;
